module.exports = __webpack_public_path__ + "static/media/flag-nl.3bc84ac6.webp";